export const telInputGlobalOptions = {
  mode: 'auto',
  dropdownOptions: { showSearchBox: true },
  inputOptions: {
    autofocus: true,
    showDialCode: true,
    placeholder: '',
    required: true
  }
}
